// OPEN KAIVERRUS POPUP
function setKaiverrus(ele) {
  jQuery('.tuote__popup--kaiverrus').addClass('open');
}



// KAIVERRUSRIVIN LISÄYS
function addRow(ele) {
  let currentrow = jQuery(ele).data('currentrow');
  let maxrow = jQuery(ele).data('maxrow');
  let lastrow = jQuery(ele).parent().prev('.kaiverrus__rivi-container').clone();
  currentrow = currentrow + 1;

  let label = lastrow.find('.kaiverrus__rivi-label');
  let row = lastrow.find('.kaiverrus__rivi');
  let count = lastrow.find('.kaiverrus__rivi-count');
  label.attr('for', 'rivi' + currentrow);
  label.html('Rivi ' + currentrow);
  row.attr('id', 'rivi' + currentrow);
  row.attr('name', 'rivi' + currentrow);
  row.val('');
  count.html('0');
  lastrow.insertBefore(jQuery(ele).parent());
  jQuery(ele).data('currentrow', currentrow);
  if ( currentrow >= maxrow ) {
    jQuery(ele).closest('.kaiverrus__rivi-container--lisaa').addClass('hidden');
  }
}



function updateRow(ele){
  let rivilen = jQuery(ele).val().length;
  if ( rivilen >= jQuery(ele).attr('maxlength') ) {
    jQuery(ele).addClass('full');
  } else {
    if ( jQuery(ele).hasClass('full') ) {
      jQuery(ele).removeClass('full');
    }
  }
  jQuery(ele).next('.kaiverrus__rivi-count').html(rivilen);

  updateRowPrice();
}

function updateRowPrice() {
  let price = getRowPrice();
  //jQuery('#kaiverrushinta').html( price.toFixed(2) + ' €');
  jQuery('#kaiverrushinta').html( price + ' merkkiä');
}

function getRowPrice() {
  let price = 0;
  //let kirjainhinta = parseFloat( jQuery('#kaiverrushinta').attr('data-kirjainhinta') );
  let count = parseInt( jQuery('#tuote__maara-count').attr('data-value') );
  let type = jQuery('.kaiverrus__valinta').val();
  //let minPrice = parseFloat(jQuery('#kaiverrushinta').attr('data-minimiveloitus'));

  jQuery('.kaiverrus__rivi').each(function(){
    let rowlen = jQuery(this).val().split(' ').join('').length;
    //let rowprice = rowlen * kirjainhinta;
    let rowprice = rowlen;
    price = price + rowprice;
  });
  if ( type == 'sama' ) {
    price = price * count;
  }

  /*
  *if ( price > 0 && price < ( count * minPrice ) ) {
  *  price = count * minPrice;
  *}
  */
  
  //return Math.round((price + Number.EPSILON) * 100) / 100;
  return price;
}



// TALLENNA KAIVERRUKSET
function saveRows() {
  saveAllRows();
  jQuery('.tuote-popup__close').click();
}

function saveAllRows() {
  let kaiverrus = '';
  jQuery('.kaiverrus__tuote-container').each(function(){
    let tuote = '';
    jQuery(this).find('.kaiverrus__rivi').each(function(){
      if ( jQuery(this).val() != '') {
        tuote += jQuery(this).val();
        tuote += '||';
      }
    });
    tuote = tuote.slice(0, -2);
    if ( tuote != '' ) {
      kaiverrus += tuote + '|||';
    }
    
  });
  kaiverrus = kaiverrus.slice(0, -3);
  jQuery('#tuote-ostoskoriin').attr('data-kaiverrus', encodeURIComponent(kaiverrus));
  updateAddToCartUrl();
  if ( kaiverrus != '' ) {
    let price = getRowPrice();
    jQuery('.tuote__kaiverrus-btn').html('Muokkaa kaiverruksia');
    jQuery('.tuote__kaiverrus-btn').addClass('set');
    //jQuery('.tuote__rivi-kaiverrus-hinta').html('Kaiverrusten pituus yhteensä <span>' + price.toFixed(2) + ' €<span>');
    jQuery('.tuote__rivi-kaiverrus-hinta').html('Kaiverrusten pituus yhteensä <span>' + price + ' merkkiä<span>');
    jQuery('.tuote__rivi-kaiverrus-hinta').addClass('set');
  } else {
    jQuery('.tuote__kaiverrus-btn').html('+ Lisää kaiverrus');
    if ( jQuery('.tuote__kaiverrus-btn').hasClass('set') ) {
      jQuery('.tuote__kaiverrus-btn').removeClass('set');
      jQuery('.tuote__rivi-kaiverrus-hinta').removeClass('set');
    }
    jQuery('.tuote__rivi-kaiverrus-hinta').html('');
  }
}



// KAIVERRUSTYYPIN VALINTA
jQuery('.kaiverrus__valinta').change(function() {
  if (this.value == 'sama') {
    jQuery('.kaiverrus__editori-otsikko').each(function(){
      jQuery(this).addClass('hidden');
    });
    if ( jQuery('.kaiverrus__tuote-container').length > 1 ) {
      jQuery('.kaiverrus__tuote-container').not('[data-tuote=1]').each(function(){
        jQuery(this).remove();
      });
    }
  }
  if (this.value == 'eri') {
    jQuery('.kaiverrus__editori-otsikko').each(function(){
      jQuery(this).removeClass('hidden');
    });
  }

  updateProductRowCount();
  jQuery('.kaiverrus__rivi').first().keyup();
});

function updateProductRowCount() {
  let kaiverrusValinta = jQuery('.kaiverrus__valinta').val();
  let productCount = parseInt( jQuery('#tuote__maara-count').attr('data-value') );
  let rowCount = jQuery('.kaiverrus__tuote-container').length;
  let rowDiff = productCount - rowCount;

  if ( kaiverrusValinta == 'eri' ) {
    if ( rowDiff > 0 ) {
      let tuote = jQuery('.kaiverrus__tuote-container').first().clone();      
      for ( let i = (rowCount + 1); i <= productCount; i++ ) {
        tuote = tuote.clone();
        let tuoteOtsikko = tuote.find('.kaiverrus__editori-otsikko');
        tuoteOtsikko.html('Tuote ' + i);
        tuote.attr('data-tuote', i);
        tuote.insertAfter(jQuery('.kaiverrus__tuote-container').last());
      }
    }

    if ( rowDiff < 0 ) {
      let absDiff = Math.abs(rowDiff)
      for ( let i = rowCount; i > rowCount - absDiff; i-- ) {
        jQuery('.kaiverrus__tuote-container[data-tuote=' + i + ']').remove();
      }
    }
  }
}